import { FaBullseye } from "react-icons/fa6";

export default function ValueCard({ text, title }) {
  return (
    <div className="p-6 h-full w-full  border-gray-500 border-2 rounded-xl border-dashed hover:shadow-2xl transition-all duration-300 cursor-pointer col-span-2">
      <div className="flex items-center justify-start gap-3 ">
        <span className="text-red-600 text-2xl">
          <FaBullseye />
        </span>
        <span className="uppercase text-center text-base text-gray-700 font-bold">
          {title}
        </span>
      </div>
    </div>
  );
}
